import { render, staticRenderFns } from "./RoundStageDropdown.vue?vue&type=template&id=1a3c9e4e&"
import script from "./RoundStageDropdown.vue?vue&type=script&lang=js&"
export * from "./RoundStageDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports